/**
 * Login Validation: 
 */

import { dId, confirm_box } from "./common.js";

const forget_pass       = <HTMLElement>dId("forget_pass");
const didnt_forget_pass = <HTMLElement>dId("didnt_forget_pass");
const password_form     = <HTMLElement>dId("password_form");
const login_form        = <HTMLElement>dId("login_form");
const login_pass        = <HTMLElement>dId("login_pass");
const login_form_inputs = <HTMLElement>dId("login_form_inputs");
const password_form_inputs = <HTMLElement>dId("password_form_inputs");
const password_view     = <HTMLElement>dId("show_pass");

//  Loader:  Shortcut - forget password, show password form:
const urlParams = new URLSearchParams(window.location.search);
if (urlParams.has('forget')) {
  password_form.style.display = "block";
  login_form.style.display = "none";
}

// Listeners: 
login_form_inputs.addEventListener("submit", function (e) {
  e.preventDefault();
  if (checklogin() ) {
    (<HTMLFormElement>e.target).submit();
  }
});

password_form_inputs.addEventListener("submit", function (e) {
  
  e.preventDefault();

  if (resetlogin() ) {
    setTimeout(() => {
    (<HTMLFormElement>e.target).submit();
    }, 3000);
  }
  
});

password_view.addEventListener("click", function () {
  if (login_pass.getAttribute("type") == "password") {
    login_pass.setAttribute("type", "text");
    password_view.style.opacity = "0.2";
    setTimeout(() => {
      login_pass.setAttribute("type", "password");
      password_view.style.opacity = "0.5";
    },2000);
  } 
});


forget_pass.addEventListener("click", function () {
  password_form.style.display = "block";
  login_form.style.display = "none";
});

didnt_forget_pass.addEventListener("click", function () {
  password_form.style.display = "none";
  login_form.style.display = "block";
});


function checklogin() {

  const user = (<HTMLInputElement>dId("login_user")).value;
  const pass = (<HTMLInputElement>dId("login_pass")).value;

  if (user.length < 3) {
    confirm_box("Por favor introduzca un nombre de usuario válido", "Aceptar", "", "", "");
    return false;
  }

  if (pass.length < 5) {
    confirm_box("Por favor introduzca una contraseña válida", "Aceptar", "", "", "");
    return false;
  }

  return true;

}


function resetlogin() {

  const mail = (<HTMLInputElement>dId("user_email")).value;

  // Check valid email format:
  const mail_regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

  if (!mail_regex.test(mail)) {
    confirm_box("Por favor introduzca una dirección de correo válida", "Aceptar", "", "", "");
    return false;
  }

  confirm_box("Hemos enviado un enlace para restablecer la contraseña a su correo electrónico.", "Aceptar", "", "", "");
  return true;

}

export { checklogin, resetlogin };